module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/77a6289e3facbaf1f2c724c873951443.png";